import React, { useEffect, useState } from 'react';
import { Tag } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { UsnStickerPrinter } from '@/components/print/UsnStickerPrinter';
import { printPacks } from '@/services/tissueJwApi';
import { fmtDate } from './JwStatusBadge';

// Pack receipts history + pack barcode label printing (same printer setup as USN stickers).
export const PackReceiptsCard = ({ order }) => {
  const [groups, setGroups] = useState([]);
  const receipts = order.receipts || [];
  useEffect(() => { printPacks(order.jw_id).then((r) => setGroups(r.groups || [])).catch(() => setGroups([])); }, [order.jw_id, receipts.length]);

  return (
    <Card data-testid="pack-receipts-card">
      <CardHeader><CardTitle className="text-base flex items-center gap-2"><Tag className="w-4 h-4" /> Pack labels & receipts</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        {receipts.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {receipts.map((r) => (
              <div key={r.receipt_id} className="border rounded-md px-3 py-2 text-xs bg-white" data-testid={`receipt-${r.receipt_id}`}>
                <p className="font-mono font-semibold">{r.receipt_id}</p>
                <p className="text-gray-500">{r.packs} packs · {r.pcs} pcs · {fmtDate(r.received_at)} · {r.staff_name || r.staff_id}</p>
                {r.inward_entry_id && <p className="text-gray-500">Inward {r.inward_entry_id}</p>}
                {(r.lines || []).map((ln) => (
                  <p key={ln.sort_no} className="font-mono text-[10px] text-gray-600 max-w-[360px] break-all" data-testid={`receipt-codes-${r.receipt_id}-${ln.sort_no}`}>
                    {ln.fg_name}: {ln.pack_codes.slice(0, 8).join(', ')}{ln.pack_codes.length > 8 ? ` … +${ln.pack_codes.length - 8}` : ''}
                  </p>
                ))}
              </div>
            ))}
          </div>
        )}
        <UsnStickerPrinter groups={groups} screenKey="tissue-pack-labels" noun="pack label" groupNoun="FG group" unit="pack" />
      </CardContent>
    </Card>
  );
};

export default PackReceiptsCard;
